import $ from 'jquery';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';

$(document).ready(function () {
    let slider = null;

    const gallery = document.querySelector('.postGallery');
    if (!gallery) {
        return;
    }
    const swiper = gallery.querySelector('.swiper');
    const nav = gallery.querySelector('.carousel__nav');
    const nextButton = gallery.querySelector('.carousel__next');
    const prevButton = gallery.querySelector('.carousel__prev');
    slider = new Swiper(swiper, {
        modules: [Navigation],
        /*autoplay: {
            pauseOnMouseEnter: true
        },*/
        autoplay: false,
        loop: false,
        navigation: {
            enabled: !!nav,
            addIcons: false,
            nextEl: nextButton,
            prevEl: prevButton,
        }
    });

    const items = gallery.getElementsByClassName('postGalleryThumbs__item');
    slider.on('slideChange', function () {
        for (let i = 0; i < items.length; i++) {
            items[i].classList.remove('active');
        }
        items[slider.realIndex].classList.add('active');
    })

    gallery.querySelector('.postGalleryThumbs').addEventListener('click', function (e) {
        e.preventDefault();
        const item = e.target.closest('.postGalleryThumbs__item');
        if (!item) {
            return;
        }
        const index = Array.from(items).indexOf(item);

        if (index !== -1) {
            slider.slideTo(index);
        }
    })
});